import Lottie from "react-lottie";
import { NavLink } from "react-router-dom";
import animationData from "assets/lottie/cool/cool_08.json";

const PortfolioInvite = () => {
    const defaultOptionsB = {
              loop: true,
              autoplay: true,
              animationData: animationData
    };
    return(
        <div className="relative w-full text-center py-16 px-8 text-white">
            <Lottie width="200px" options={defaultOptionsB} isClickToPauseDisabled={true} style={{
                cursor:"default",
                // filter: "invert(1)"
            }}/>
            <h2 className="text-4xl font-title font-extrabold mb-6 leading-tight">
                See Our Latest Work!
            </h2>
            <p className="text-lg font-body mb-8">
                Explore how we’ve brought ideas to life with stunning animations for our
                clients around the world.
            </p>
            <NavLink to="/portfolio">
                <button
                    className="border-[5px] border-yellow-400 hover:tracking-widest relative px-8 py-3 text-2xl font-bold rounded-full shadow-lg overflow-hidden transition-all duration-300 transform hover:scale-110
                    before:absolute before:inset-0 before:bg-gradient-to-r before:from-pink-500 before:to-purple-600 before:opacity-0 before:transition-opacity before:duration-300 hover:before:opacity-100 before:-z-10"
                    style={{
                    background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                    }}
                >
                    <span className="relative z-10">View Portfolio</span>
                </button>
            </NavLink>
        </div>
    )
}

export default PortfolioInvite;
